function formatFirestoreDate(dateStr) {
  if (!dateStr) return '';

  let date;
  // Handle Firestore Timestamp
  if (dateStr && typeof dateStr.toDate === 'function') {
    date = dateStr.toDate();
  } else {
    date = new Date(dateStr);
  }

  // Check for invalid date
  if (isNaN(date.getTime())) return '';

  // Match API: instants are stored with UTC offset; show calendar + clock in UTC
  const dateOptions = {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  };
  const formattedDate = date.toLocaleDateString('en-US', dateOptions);

  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  const displayMinutes = minutes > 0 ? `:${minutes.toString().padStart(2, '0')}` : '';
  const formattedTime = `${displayHours}${displayMinutes}${ampm}`;

  // Return: "Fri, Jul 18 | 9PM"
  return `${formattedDate} | ${formattedTime}`;
}

function formatEventDateOnly(dateStr) {
  if (!dateStr) return "";

  let date;
  if (dateStr && typeof dateStr.toDate === "function") {
    date = dateStr.toDate();
  } else {
    date = new Date(dateStr);
  }

  if (isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-US", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  });
}

export { formatFirestoreDate, formatEventDateOnly };
